import axios from 'api';

// /api/super/workspace-assistant/ — single platform-wide config for the
// Workspace Assistant. A sibling of the prompt-generator row, not the same
// one: the assistant makes two small calls per turn where latency and cost
// dominate, so it gets its own gateway and can point at a different model.
//
//   Connection : base_url, api_key, model, temperature (number), max_tokens (number)
//   Prompts    : planner_prompt, composer_prompt
//
// GET never returns api_key. It returns api_key_set (bool) and api_key_hint
// (last four characters) instead, so the UI can say whether a key is
// configured without ever rendering the credential.
//
// Session cookie + X-CSRFToken are attached by the shared axios instance.
const BASE = '/api/super/workspace-assistant/';

export const getAssistantConfig = (signal) => axios.get(BASE, { signal });

// Body: any subset of the fields above. Send only what changed — PATCH is
// partial, and omitting `api_key` leaves the stored key untouched. Sending a
// key back that came from a GET is impossible by design, since GET never
// includes it.
export const updateAssistantConfig = (body) => axios.patch(BASE, body);

// Restores the shipped prompts, leaving the gateway fields alone. Optional
// body { prompts: ['composer_prompt'] } resets a subset; omitted, both go back.
// The singleton keeps no version history, so this is the only way back from an
// edit that broke the turn loop.
export const resetAssistantPrompts = (prompts) => axios.post(`${BASE}reset-prompts/`, prompts ? { prompts } : {});
